"use client";
import { jsxs as T, jsx as m } from "react/jsx-runtime";
import { JUSTIFIED_GALLERY_DEFAULT_HEIGHTS as _ } from "./constants.mjs";
import { getItemRenderData as D, getItemStyleProps as L, getGapStyle as N } from "./utils.mjs";
import { Skeleton as w } from "../../atoms/Skeleton/Skeleton.mjs";
import { cn as y } from "../../../utils/utils.mjs";
const c = "h-(--h-sm) @min-[768px]/gallery:h-(--h-md) @min-[1024px]/gallery:h-(--h-lg) @min-[1800px]/gallery:h-(--h-xl)", B = ({
  items: t,
  responsiveHeights: a = _,
  rowGapPx: r = 8,
  columnGapPx: u = 8,
  className: S,
  children: E,
  stretchLastRow: I = !1,
  isLoading: G = !1,
  skeletonProps: l,
  ...$
}) => /* @__PURE__ */ T(
  "div",
  {
    "data-testid": "justified-gallery",
    className: y("flex flex-wrap @container/gallery", S),
    style: {
      gap: N(r, u),
      "--h-sm": `${a == null ? void 0 : a.sm}px`,
      "--h-md": `${a == null ? void 0 : a.md}px`,
      "--h-lg": `${a == null ? void 0 : a.lg}px`,
      "--h-xl": `${a == null ? void 0 : a.xl}px`
    },
    ...$,
    children: [
      t.map((d, j) => {
        const f = D(d, j), x = L(f.aspectRatio);
        return G ? /* @__PURE__ */ m(
          w,
          {
            "data-testid": `skeleton-loader-${d.id}`,
            animation: "shimmer",
            ...l,
            className: y(c, l == null ? void 0 : l.className),
            style: { ...l == null ? void 0 : l.style, ...x }
          },
          d.id
        ) : /* @__PURE__ */ m(
          "div",
          {
            "data-testid": `justified-gallery-item-${d.id}`,
            className: c,
            style: x,
            children: E(f)
          },
          d.id
        );
      }),
      !I && t.length > 0 && /* @__PURE__ */ m(
        "div",
        {
          "aria-hidden": !0,
          "data-testid": "justified-gallery-row-filler",
          style: { flexGrow: 1e6, flexBasis: 0 }
        }
      )
    ]
  }
);
export {
  B as JustifiedGallery
};
